import { FaqCategory } from "./faq-category-model";
export class Faq {
  public id: string;
  public faqID: number;
  public question: string;
  public answers: string;
  public views: number;
  public faqCategoryID: number;
  public faqCategory: FaqCategory;
}



// WEBPACK FOOTER //
// ./src/app/models/faq/faq-model.ts